import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a4139c58"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "item"
};
const _hoisted_4 = {
  class: "num"
};
const _hoisted_5 = {
  class: "bottom"
};
const _hoisted_6 = {
  class: "item"
};
const _hoisted_7 = {
  class: "num"
};
const _hoisted_8 = {
  class: "bottom"
};
const _hoisted_9 = {
  class: "item"
};
const _hoisted_10 = {
  class: "num"
};
const _hoisted_11 = {
  class: "bottom"
};
const _hoisted_12 = {
  class: "item"
};
const _hoisted_13 = {
  class: "num"
};
const _hoisted_14 = {
  class: "bottom"
};
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"content\" data-v-a4139c58><div class=\"time-info border\" id=\"box13\" data-v-a4139c58><div class=\"title\" data-v-a4139c58>月销售额</div><div id=\"charts\" style=\"width:100%;height:300px;\" data-v-a4139c58></div></div><div class=\"area border\" id=\"box1\" data-v-a4139c58>比例分配 <div id=\"pie\" style=\"width:100%;height:300px;\" data-v-a4139c58></div></div></div>", 1);
const _hoisted_16 = {
  class: "home-footer"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", null, "今日订单")], -1));
const _hoisted_18 = {
  class: "text item"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "今日收藏数", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "今日累计金额", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "今日订单数", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", null, "本月订单")], -1));
const _hoisted_23 = {
  class: "text item"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "收藏量", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "累计金额", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "累计下单量", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", null, "快捷入口")], -1));
const _hoisted_28 = {
  class: "text item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_card = _resolveComponent("el-card");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(" 总销售额 "), _createElementVNode("div", _hoisted_4, _toDisplayString($setup.homeInfo.saleTotal), 1), _createElementVNode("div", _hoisted_5, "今日销售额：" + _toDisplayString($setup.homeInfo.sale), 1)]), _createElementVNode("div", _hoisted_6, [_createTextVNode("访问量 "), _createElementVNode("div", _hoisted_7, _toDisplayString($setup.homeInfo.viewsTotal), 1), _createElementVNode("div", _hoisted_8, "今日访问量：" + _toDisplayString($setup.homeInfo.views), 1)]), _createElementVNode("div", _hoisted_9, [_createTextVNode("收藏量 "), _createElementVNode("div", _hoisted_10, _toDisplayString($setup.homeInfo.collectTotal), 1), _createElementVNode("div", _hoisted_11, "今日收藏量：" + _toDisplayString($setup.homeInfo.collect), 1)]), _createElementVNode("div", _hoisted_12, [_createTextVNode("支付量 "), _createElementVNode("div", _hoisted_13, _toDisplayString($setup.homeInfo.payTotal), 1), _createElementVNode("div", _hoisted_14, "今日支付量：" + _toDisplayString($setup.homeInfo.pay), 1)])]), _hoisted_15, _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_card, {
    class: "box-card"
  }, {
    header: _withCtx(() => [_hoisted_17]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_hoisted_19, _createElementVNode("div", null, _toDisplayString($setup.homeOrder.curCollect), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_hoisted_20, _createElementVNode("div", null, _toDisplayString($setup.homeOrder.curMoney), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_hoisted_21, _createElementVNode("div", null, _toDisplayString($setup.homeOrder.curOrderCount), 1)]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  }), _createVNode(_component_el_card, {
    class: "box-card"
  }, {
    header: _withCtx(() => [_hoisted_22]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_hoisted_24, _createElementVNode("div", null, _toDisplayString($setup.homeOrder.collect), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_hoisted_25, _createElementVNode("div", null, _toDisplayString($setup.homeOrder.money), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_hoisted_26, _createElementVNode("div", null, _toDisplayString($setup.homeOrder.orderCount), 1)]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  }), _createVNode(_component_el_card, {
    class: "box-card"
  }, {
    header: _withCtx(() => [_hoisted_27]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_createVNode(_component_el_button, {
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode("产品管理")]),
      _: 1
    }), _createVNode(_component_el_button, null, {
      default: _withCtx(() => [_createTextVNode("消息管理")]),
      _: 1
    }), _createVNode(_component_el_button, null, {
      default: _withCtx(() => [_createTextVNode("内容管理")]),
      _: 1
    })])]),
    _: 1
  })])]);
}